const AUDIENCES = [
  {
    label: "For Support Coordinators",
    title: "Responsive capacity & transparent reporting",
    text: "Fast intake turnaround, clear service agreements, and dependable case notes. Book introduction meetings on behalf of your participants directly.",
    points: ["Direct appointment booking", "Prompt response within 24 business hours", "Detailed progress updates for reviews"],
  },
  {
    label: "For People with Disability",
    title: "Choice, control, and consistent friendly faces",
    text: "You choose who supports you and what your days look like. We match you with support workers who share your interests and respect your pace.",
    points: ["Support workers matched to your personality", "Your schedule, your preferred times", "Dignity and independence at every step"],
  },
  {
    label: "For Families & Carers",
    title: "Peace of mind and personal communication",
    text: "Stay in the loop with consistent updates and direct access to coordinators. Knowing your loved one is supported by experienced, caring professionals.",
    points: ["Consistent, vetted support staff", "Flexible respite options when you need rest", "Direct contact with our local leadership"],
  },
];

export default function Audiences() {
  return (
    <section id="audiences" className="py-20 px-5 sm:px-8 bg-[#FAF8F5]" data-testid="audiences-section">
      <div className="max-w-6xl mx-auto space-y-12">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-xs uppercase tracking-widest text-[#786655] font-semibold">Who We Partner With</span>
          <h2 className="text-3xl sm:text-4xl font-display font-medium text-[#1E282D] mt-2">Built equally for coordinators, participants, and families</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {AUDIENCES.map((a) => (
            <div key={a.label} className="p-7 rounded-2xl bg-[#F6F1EA] border border-[#E7E0D3] space-y-4">
              <div className="text-sm font-semibold uppercase tracking-wider text-[#6F5F50]">{a.label}</div>
              <h3 className="text-xl font-display font-medium text-[#1E282D]">{a.title}</h3>
              <p className="text-sm text-[#4F5C63] leading-relaxed">{a.text}</p>
              <ul className="text-xs text-[#4F5C63] space-y-2 pt-2">
                {a.points.map((point) => (
                  <li key={point} className="flex items-center gap-2">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#7B6D5F]" />{point}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
